import "./index.css";
import { Layout } from "@/components/Layout";
import { Dashboard } from "@/components/Dashboard";
import { Sequences } from "@/components/Sequences";
import { SequenceDetail } from "@/components/SequenceDetail";
import { Contacts } from "@/components/Contacts";
import { AIWriter } from "@/components/AIWriter";
import { useAppStore } from "@/lib/store";

export function App() {
	const store = useAppStore();

	function renderPage() {
		switch (store.page) {
			case "dashboard":
				return <Dashboard />;
			case "sequences":
				return (
					<Sequences
						sequences={store.sequences}
						onSelect={(id) => store.navigate("sequence-detail", id)}
					/>
				);
			case "sequence-detail": {
				const seq = store.sequences.find((s) => s.id === store.selectedSequenceId);
				if (!seq) return <Sequences sequences={store.sequences} onSelect={(id) => store.navigate("sequence-detail", id)} />;
				return (
					<SequenceDetail
						sequence={seq}
						onBack={() => store.navigate("sequences")}
					/>
				);
			}
			case "contacts":
				return <Contacts contacts={store.contacts} sequences={store.sequences} />;
			case "ai-writer":
				return <AIWriter />;
			default:
				return <Dashboard />;
		}
	}

	return (
		<Layout currentPage={store.page} onNavigate={(page) => store.navigate(page)}>
			{renderPage()}
		</Layout>
	);
}

export default App;
